import React, { useEffect, useMemo, useState } from 'react';
import ChatHeader from 'pages/chats/components/Header';
import proposalIsFinished from 'pages/chats/helpers/proposalIsFinished';
import Page from 'components/Page';
import Chat from '../components/Chat';
import SideBar from './components/SideBar';
import SubHeader from '../components/SubHeader';
import { Container, Content } from './styles';
import { ConfirmActionDialog } from '../components/ConfirmActionDialog';
import Lead360 from '../components/SideBarComponents/Lead360';

const ChatShowroomComponent = ({
  currentProposal,
  handleOnClickBack,
  handleOnClickClose,
  onModal,
  proposalError,
  loadedProposal,
}) => {
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState<boolean>(
    false
  );

  const proposalId = currentProposal?.id;
  const proposalDealerId = currentProposal?.dealerId;

  const handleOpenConfirmationDialog = () => {
    setTimeout(() => {
      return setOpenConfirmationDialog(true);
    }, 1500);
  };

  const triggerShowConfirmationDialog = useMemo(() => {
    const showPopUpInThisProposal = currentProposal?.showPopUpToSeller;

    return showPopUpInThisProposal;
  }, [currentProposal]);

  const dontShowMessageToBlockPopup =
    currentProposal?.dontShowMessageToBlockPopup;

  useEffect(() => {
    if (loadedProposal && triggerShowConfirmationDialog) {
      handleOpenConfirmationDialog();
    }
  }, [loadedProposal, triggerShowConfirmationDialog]);

  return (
    <Page withoutPadding>
      <ChatHeader
        error={proposalError}
        currentProposal={currentProposal}
        handleOnClickBack={handleOnClickBack}
        onModal={onModal}
        handleOnClickClose={handleOnClickClose}
      />
      <Container isFinished={proposalIsFinished(currentProposal)}>
        <SubHeader currentProposalStatus={currentProposal.status} />
        <Content>
          <Chat />
          <SideBar />
        </Content>
      </Container>
      {triggerShowConfirmationDialog && (
        <ConfirmActionDialog
          dealerId={proposalDealerId}
          proposalId={proposalId}
          isOpen={openConfirmationDialog}
          dontShowMessageToBlockPopup={dontShowMessageToBlockPopup}
          onClose={() => setOpenConfirmationDialog(false)}
        >
          <Lead360 mode="COMPACT" />
        </ConfirmActionDialog>
      )}
    </Page>
  );
};

export default ChatShowroomComponent;
